import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import FAQ from './FAQ';
import {
  makeSelectCollectionDetail,
  makeSelectCollectionData,
  makeSelectLoading,
  makeSelectPage,
  makeSelectSimilarCollection,
  makeSelectCollectionsOfMonths,
} from './selectors';
import HeroSlideShow from '../HeroSlideShow';
import IllustCollectionsBanner from '../../../static/images/collection-page/slideshow-illust_ac.jpg';
import withI18next from '~/../hocs/_withI18next';
import Gallery from '~/components/Gallery';
import GridGallery from '~/components/Gallery/GridGallery';
import LoadingSpinner from '~/components/loading-spinner/LoadingSpinner';
import NextPageButtonCustom from '~/components/NextPageButtonCustom';
import Config from '~/config';
import Container from '~/components/Container';
import themeVariables from '~/shared/themeVariables';
import CollectionBreadcrumb from '~/components/CollectionBreadcrumb';
import HeroBanner from '~/containers/HeroBanner';
import { loadDataCollectionById } from '~/containers/CollectionPageDetail/actions';
import CollectionItem from '~/components/CollectionItem';
import TagTrending from '~/components/TagTrending';
import PreviousPageButtonCustom from '~/components/PreviousPageButtonCustom';
import { fileHelper } from '~/utils';
import LinkTo from '~/components/LinkTo';
import { makeSelectIsCountdownActive } from '~/containers/PaymentModal/selectors';
import BannerDiscount from '~/components/BannerDiscount';
import {
  makeSelectProfile,
  makeSelectIsAuthenticated,
} from '~/containers/AuthProvider/selectors';
import GalleryIllust from '~/components/Gallery/GalleryIllust';
import PaginationStaticPage from '~/components/PaginationStaticPage';

const roles = Config.getRoles();

@withI18next(['page-collections'])
class CollectionPageDetail extends React.Component {
  renderNavigationAndBreadCrumb({ t, collectionName, page, totalPage, slug }) {
    const pageText = t('page_text', { page });
    return (
      <div className="breadcrumb-wrapper">
        <div className="breadcrumb-left">
          {+page === 1 ? (
            <CollectionBreadcrumb collectionName={collectionName} />
          ) : (
            <CollectionBreadcrumb
              collectionName={`${collectionName}`}
              pageText={pageText}
              page={+page}
            />
          )}
        </div>
        <div className="pagination-top">
          <PaginationStaticPage
            currentPage={+page}
            totalPage={+totalPage}
            path="/collection"
            asPath={`/collection/${slug}`}
          />
        </div>
        <style jsx>
          {`
            .breadcrumb-wrapper {
              display: flex;
              margin-bottom: 32px;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
            }

            .breadcrumb-left {
              font-size: 24px;
            }

            @media only screen and (max-width: ${themeVariables.breakpoints
                .tabletS.minWidth}px) {
              .pagination-top {
                display: none;
              }
            }
          `}
        </style>
      </div>
    );
  }

  isUsingGridGallery = (dataType) =>
    dataType === Config.roles.POWERPOINT ||
    dataType === Config.roles.WEB_TEMPLATE ||
    dataType === Config.roles.ADSENSE;

  renderGridLayout(dataType) {
    const imageSize = Config.getFixedSizeByDataType(dataType);

    if (this.isUsingGridGallery(dataType)) {
      return (
        <GridGallery
          images={this.props.collectionData.photos}
          currentLang={this.props.currentLanguage}
          lastRowHide={false}
          colWidth={imageSize.width}
          rowHeight={imageSize.height}
          showImageActions
          api={this.props.api}
        />
      );
    }
    if (Config.isIllustAC()) {
      return (
        <GalleryIllust
          images={this.props.collectionData.photos}
          currentLang={this.props.currentLanguage}
          lastRowHide={false}
          prepareLoad={this.props.loading}
          showImageActions
          api={this.props.api}
          toggleFilterSearch={false} //fake = true to reduce count image in row
          isNotFullWidthCustom={true} // reduce count image when not full 100vw
          profile={this.props.profile}
        />
      );
    }
    return (
      <Gallery
        images={this.props.collectionData.photos}
        currentLang={this.props.currentLanguage}
        lastRowHide={false}
        colWidth={imageSize.width}
        rowHeight={imageSize.height}
        prepareLoad={this.props.loading}
        showImageActions
        api={this.props.api}
      />
    );
  }

  onNextLink() {
    const { collectionDetail } = this.props;
    const slug = collectionDetail.slug + '-' + collectionDetail.id;
    let currentPage = this.props.collectionData.page;

    currentPage = Number(currentPage) + 1;

    currentPage = currentPage === 1 ? '' : `/${currentPage}`;

    const path = `/${this.props.lng}/collection/${slug}${currentPage}`;
    return {
      asPath: path,
      path,
    };
  }
  onPreviousLink() {
    const { collectionDetail } = this.props;
    const slug = collectionDetail.slug + '-' + collectionDetail.id;
    let currentPage = this.props.collectionData.page;

    currentPage = Number(currentPage) - 1;
    currentPage = currentPage === 1 ? '' : `/${currentPage}`;

    const path = `/${this.props.lng}/collection/${slug}${currentPage}`;
    return {
      asPath: path,
      path,
    };
  }

  renderOtherService = (data) => {
    const { t } = this.props;
    const key = Object.keys(data).filter((serviceType) => {
      return serviceType !== null;
    });
    return key.map((serviceType, key) => {
      return (
        <Container
          key={key}
          style={{
            background: themeVariables.color.white,
            paddingTop: 32,
            paddingBottom: 32,
          }}
        >
          <div className="similar-collection-header">
            <p className="collection-similar-title">
              {t(
                `${Config.getPrefix(
                  serviceType,
                )}_explore_more_collections_from`,
              )}
            </p>
            <LinkTo
              label={t('view_all')}
              href="/collections"
              host={Config.getSiteURL(serviceType)}
            />
          </div>
          <div className="container-collections">
            {data[serviceType].map((data, idx) => {
              return (
                <CollectionItem
                  key={idx}
                  data={data}
                  t={t}
                  serviceType={serviceType}
                />
              );
            })}
          </div>
          <style>
            {`
              .container-collections {
                  display: grid;
                  grid-gap: 24px;
                  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
                  margin-top:16px;
                }
              .collection-similar-title{
                  font-style: normal;
                  font-weight: 600;
                  font-size: 24px;
                  line-height: 28px;
                  color: #1b2833;
              }
              .similar-collection-header{
                  display:flex;
                  flex-direction:row;
                  justify-content:space-between;
              }
              `}
          </style>
        </Container>
      );
    });
  };

  renderCollectionOfMonths = (data) => {
    const { t } = this.props;
    return (
      <Container
        style={{
          background: themeVariables.color.white,
          paddingTop: 64,
          paddingBottom: 64,
        }}
      >
        <div className="similar-collection-header">
          <p className="collection-similar-title">
            {t('header_collection_of_months')}
          </p>
        </div>
        <div className="container-collections">
          {data.map((data, idx) => {
            return <CollectionItem key={idx} data={data} t={t} />;
          })}
        </div>
        <style>
          {`
              .container-collections {
                  display: grid;
                  grid-gap: 24px;
                  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
                }
              .collection-similar-title{
                  font-style: normal;
                  font-weight: 600;
                  font-size: 24px;
                  line-height: 28px;
                  color: #1b2833;
              }
              .similar-collection-header{
                  display:flex;
                  flex-direction:row;
                  justify-content:space-between;
              }
              `}
        </style>
      </Container>
    );
  };

  render() {
    const {
      currentLanguage,
      t,
      collectionDetail,
      collectionData,
      loading,
      similarCollections,
      collectionOfMonths,
      profile,
      isCountdownActive,
    } = this.props;
    const { page, total_page, dataType, has_next, photos } = collectionData;
    const per_page = collectionData.max_results;
    const pathSlug = collectionDetail.slug + '-' + collectionDetail.id;

    const isDiscountDisplayed =
      profile.role !== roles.PREMIUM &&
      profile.role !== roles.CREATOR &&
      isCountdownActive;

    return (
      <div className="category-page">
        <div className="detail-tag-cover">
          {Config.isDesignAC() ? (
            <HeroSlideShow />
          ) : (
            <HeroBanner
              imageURL={
                Config.isIllustAC()
                  ? IllustCollectionsBanner
                  : `${Config.staticPrefix}/static/images/collection-page/slideshow-${Config.serviceType}.png`
              }
              title={t(Config.getPrefixContent('collection_detail_heading'), {
                collectionName: fileHelper.capitalizeString(
                  collectionDetail.name,
                ),
              })}
              subTitle={t(
                Config.getPrefixContent('collection_detail_description'),
                {
                  keyword: 'titleCoverName',
                  number: 'collectionNumber',
                  collectionName: fileHelper.capitalizeString(
                    collectionDetail.name,
                  ),
                },
              )}
              hiddenExplore={true}
              responsive={true}
            />
          )}
        </div>
        {isDiscountDisplayed && <BannerDiscount />}

        <Container className="collection-photo-container">
          {this.renderNavigationAndBreadCrumb({
            t,
            currentLanguage,
            collectionName: collectionDetail.name,
            page,
            perPage: per_page || 100,
            totalPage: total_page,
            query: this.props.query,
            slug: pathSlug,
          })}
          {!loading ? this.renderGridLayout(dataType) : <LoadingSpinner />}
          {photos.length > 0 && (
            <div className="bottom-pagination">
              <div className="button-next-page">
                {has_next && (
                  <NextPageButtonCustom
                    pathname={this.onNextLink().path}
                    as={this.onNextLink().asPath}
                    t={t}
                    type="next_page"
                    label={t('next_page')}
                  />
                )}
                {total_page > 1 && !has_next && (
                  <PreviousPageButtonCustom
                    style={{ marginBottom: 8 }}
                    pathname={this.onPreviousLink().path}
                    as={this.onPreviousLink().asPath}
                    t={t}
                    label={t('previous_page')}
                  />
                )}
              </div>
              <PaginationStaticPage
                currentPage={+page}
                totalPage={+total_page}
                path="/collection"
                asPath={`/collection/${pathSlug}`}
              />
            </div>
          )}
        </Container>

        <Container className="seo-text-container">
          <p
            className="detail-cover-sub-title"
            dangerouslySetInnerHTML={{
              __html: t(Config.getPrefixContent('des_detail_collection'), {
                collectionName: fileHelper.capitalizeString(
                  collectionDetail.name,
                ),
                linkExtraLicense: '/extra-license',
              }),
            }}
          />
        </Container>

        {this.renderCollectionOfMonths(collectionOfMonths)}

        <TagTrending />

        {this.renderOtherService(similarCollections)}
        {/* {isAuthenticated && <SEOTextACworks />} */}
        <FAQ t={t} />

        <style jsx>
          {`
            .category-page {
              margin-bottom: 64px;
            }

            .bottom-pagination {
              width: 100%;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: space-between;
              margin-top: 32px;
            }

            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .bottom-pagination {
                flex-direction: column;
              }
            }
          `}
        </style>
        <style jsx global>
          {`
            .category-page .breadcrumb-wrapper .pagination-right {
              justify-content: flex-end;
              padding-right: 15px;
            }

            .category-page .filter-item {
              display: flex;
              min-width: 350px;
            }

            .seo-text-container {
              background: ${themeVariables.color.gray};
              padding-top: 32px;
              padding-bottom: 32px;
            }

            .category-page .filter-title {
              flex-basis: 0;
              flex-grow: 1;
            }

            .category-page .filter-content {
              flex-basis: 0;
              flex-grow: 2;
              display: flex;
            }
            .collection-photo-container {
              background: '#fff';
              padding-top: 64px;
              padding-bottom: 64px;
            }
            .category-page .padding-sa {
              padding: 23px;
            }
            .link-extra-license {
              color: ${themeVariables.colors.primary} !important;
              text-decoration-line: underline;
            }
            .link-extra-license:hover {
              text-decoration-line: underline !important;
              color: ${themeVariables.colors.primary};
              opacity: 0.9;
            }
            @media only screen and (max-width: 1015px) {
              .category-page .padding-sa {
                display: none;
              }
            }

            @media only screen and (max-width: ${themeVariables.breakpoints
                .tabletS.minWidth}px) {
              .category-page .breadcrumb-wrapper {
                display: block;
              }
              .detail-tag-cover,
              .button-next-page {
                display: none;
              }
              .seo-text-container {
                display: ${!profile.role || profile.role === roles.GUEST
                  ? 'block'
                  : 'none'} !important;
              }
              .collection-photo-container {
                padding-top: 16px;
                padding-bottom: 16px;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  collectionDetail: makeSelectCollectionDetail(),
  collectionData: makeSelectCollectionData(),
  similarCollections: makeSelectSimilarCollection(),
  loading: makeSelectLoading(),
  collectionOfMonths: makeSelectCollectionsOfMonths(),
  profile: makeSelectProfile(),
  isAuthenticated: makeSelectIsAuthenticated(),
  page: makeSelectPage(),
  isCountdownActive: makeSelectIsCountdownActive(),
});
const mapDispatchToProps = (dispatch) => ({
  loadDataCollectionById: (query) => dispatch(loadDataCollectionById(query)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CollectionPageDetail);
